import {
    RESET_ORDER,
    UPDATE_ORDER,
    SET_BRANCHES,
    UPDATE_SELECTED_BRANCH,
    SET_DELIVERY_SITES,
    UPDATE_SELECTED_DELIVERY_SITE,
    SET_VALID_QUOTES,
    UPDATE_SELECTED_QUOTE,
    UPDATE_ORDER_NUMBER,
    UPDATE_SPECIAL_INSTRUCTIONS,
    UPDATE_REQ_DELIVERY_DATE,
    UPDATE_WEIGHT,
    SET_PRODUCT_LIST,
    SET_PRODUCT_GROUPS,
    UPDATE_PRODUCT_LIST,
    SET_MIN_AND_MAX_ORDER_WEIGHT,
    SET_CUSTOMER_SURCHARGES_LIST,
    SET_SELECTED_PRODUCTS_LIST,
    SET_ORDER_SUMMARY_RESULT,
    RESET_ORDER_SUMMARY_RESULT,
    SET_PRODUCT_PRICE_PREVIEW,
    FORCE_USER_BACK,
    UPDATE_NMBS_REFERENCE,
    INSERT_ORDER,
    UPDATE_FPMCCANN_ORDER_NUMBER,
    POPULATE_FROM_BASKET,
    DELETE_BASKET,
    SET_ORDER_ERROR,
    SET_ORDER_SUMMARY_ERROR,
    RETURN_PALLETS,
    UPDATE_LORRYLOAD,
    TILE_INTEREST,
    SET_SEARCH_TEXT, 
    SET_PRODUCT_LOADING,
    RESET_PRODUCT_BASKET
} from '../actions/types';
import { isEmpty } from "lodash";



const INITIAL_STATE = {
    orderProcessStarted: false,
    productList: [],
    productGroups: [],
    cusOrderNumber: '',
    branchList: [],
    selectedBranchId: 0,
    deliverySiteList: [],
    selectedDeliverySiteId: 0,
    quoteList: [],
    selectedQuoteId: 0,
    reqDelDate: '',
    specialInstructions: '',
    lorryLoads: 0,
    totalWeight: 0,
    maxOrderWeight: 0,
    minOrderWeight: 0,
    customerSurchargesList: [],
    orderSummaryProducts: [],
    surchargeNeeded: false,
    surchargePercentage: 0,
    nmbsReference: '',
    orderSummaryResult: [],
    productPricePreview: {},
    forceUserBack: true,
    fpmccann_OrderNumber: '',
    errorOccurred: false,
    errorMessage: '',
    errorOccurredSummaryPage: false,
    errorOccurredSavingOrder: false,
    palletsRequired: false,
    lorryLoad: 0,
    tileInterest: false,
    searchText: '',
    productLoading: false
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case RESET_ORDER:
            return {
                ...state,
                orderProcessStarted: false,
                productList: [],
                productGroups: [],
                cusOrderNumber: '',
                branchList: [],
                selectedBranchId: 0,
                deliverySiteList: [],
                selectedDeliverySiteId: 0,
                quoteList: [],
                selectedQuoteId: 0,
                reqDelDate: '',
                specialInstructions: '',
                lorryLoad: 0,
                totalWeight: 0,
                maxOrderWeight: 0,
                minOrderWeight: 0,
                customerSurchargesList: [],
                orderSummaryProducts: [],
                surchargeNeeded: false,
                surchargePercentage: 0,
                nmbsReference: '',
                orderSummaryResult: [],
                productPricePreview: {},
                forceUserBack: true,
                fpmccann_OrderNumber: '',
                errorOccurred: false,
                errorMessage: '',
                errorOccurredSummaryPage: false,
                errorOccurredSavingOrder: false,
                tileInterest: false,
                searchText: '',
                productLoading: false,
                anyItemsInBasket: false,
            };

        case SET_BRANCHES:
            return { ...state, branchList: action.payload };
        case UPDATE_SELECTED_BRANCH:
            return { ...state, selectedBranchId: action.payload };

        case SET_DELIVERY_SITES:
            return { ...state, deliverySiteList: action.payload, orderProcessStarted: true };
            
        case UPDATE_SELECTED_DELIVERY_SITE:
            return { ...state, selectedDeliverySiteId: action.payload };

        case SET_VALID_QUOTES:
            return { ...state, quoteList: action.payload };
            
        case UPDATE_SELECTED_QUOTE:
            return { ...state, selectedQuoteId: action.payload };

        case SET_PRODUCT_LIST:
            return { ...state, productList: action.payload, productPricePreview: {} };

        case SET_PRODUCT_GROUPS:
            return { ...state, productGroups: action.payload };

        case UPDATE_PRODUCT_LIST:
            return { ...state, productList: action.payload };

        case UPDATE_ORDER_NUMBER:
            return { ...state, cusOrderNumber: action.payload };

        case UPDATE_SPECIAL_INSTRUCTIONS:
            return { ...state, specialInstructions: action.payload };

        case UPDATE_REQ_DELIVERY_DATE:
            return { ...state, reqDelDate: action.payload };

        case UPDATE_WEIGHT:
            return { ...state, totalWeight: action.payload.weight };

        case UPDATE_LORRYLOAD:
            return { ...state, lorryLoad: action.payload.truckLoad };

        case SET_MIN_AND_MAX_ORDER_WEIGHT:
            return { ...state, minOrderWeight: action.payload.minWeight, maxOrderWeight: action.payload.maxWeight }

        case SET_CUSTOMER_SURCHARGES_LIST:
            return { ...state, customerSurchargesList: action.payload };

        case SET_SELECTED_PRODUCTS_LIST:
            return { ...state, orderSummaryProducts: action.payload.productList, surchargeNeeded: action.payload.surchargeNeeded, surchargePercentage: action.payload.surchargePercentage, searchText: '' };

        case SET_ORDER_SUMMARY_RESULT:
            return { ...state, orderSummaryResult: action.payload, errorOccurredSummaryPage: false, errorOccurredSavingOrder: false };

        case RESET_ORDER_SUMMARY_RESULT:
            return { ...state, orderSummaryResult: [] };

        case SET_PRODUCT_PRICE_PREVIEW:
            return { ...state, productPricePreview: action.payload };

        case FORCE_USER_BACK:
            return { ...state, forceUserBack: action.payload };

        case UPDATE_NMBS_REFERENCE:
            return { ...state, nmbsReference: action.payload };

        case INSERT_ORDER:
            return { ...state, insertOrderSucess: action.payload };

        case UPDATE_FPMCCANN_ORDER_NUMBER:
            return { ...state, fpmccann_OrderNumber: action.payload };

        case POPULATE_FROM_BASKET:

            //update the weights and set totalweight

            var overallWeight = 0;
            var truckLoad = 0;

            let products = [...state.productList];



            if (action.payload.basketItems.length > 0) {
                for (let i = 0; i < action.payload.basketItems.length; i++) {

                    var row = products.find(item => item.productId === parseInt(action.payload.basketItems[i].productId))

                    row.units = parseInt(action.payload.basketItems[i].units);
                    row.packs = parseInt(action.payload.basketItems[i].packs);
                    row.quantity = (parseFloat(row.packSize) * parseFloat(row.packs)) + parseFloat(row.units);
                    row.totalWeight = parseFloat(row.quantity) * parseFloat(row.weight);
                    row.totalWeight = row.totalWeight.toFixed(4);
                }

                for (var j in products) {

                    var xtotWeight = products[j].totalWeight;
                    overallWeight = +overallWeight + +xtotWeight;

                    var cadebyLorryWeight = 26; //24
                    truckLoad = parseFloat(overallWeight) / cadebyLorryWeight

                }
            }
            return {
                ...state,
                selectedBranchId: action.payload.branchId,
                specialInstructions: action.payload.cusSpecialInstructions,
                cusOrderNumber: action.payload.customerOrderNo,
                reqDelDate: action.payload.customerReqDateString,
                selectedDeliverySiteId: action.payload.deliverySiteId,
                selectedQuoteId: action.payload.quoteId,
                productList: products,
                totalWeight: overallWeight.toFixed(4),
                lorryLoad: truckLoad.toFixed(2),

            };


        case DELETE_BASKET:

            var overallWeight = 0;
            var truckLoad = 0;

            let productsList = [...state.productList];
            for (var j in productsList) {

                productsList[j].packs = parseInt(0);
                productsList[j].units = parseInt(0);
                productsList[j].totalWeight = parseFloat(0);
                productsList[j].quantity = parseInt(0);

            }

            //get list of branches, if no branches set selectedBranch to 0

            var newBranchId = parseInt(0);
            var newDelId = parseInt(0);

            if (!isEmpty(state.branchList)) {
                newBranchId = state.branchList[0].id;
            }

            if (!isEmpty(state.deliverySiteList)) {
                newDelId = state.deliverySiteList[0].id;
            }

            return {
                ...state,
                selectedBranchId: parseInt(newBranchId),
                specialInstructions: '',
                cusOrderNumber: '',
                reqDelDate: '',
                selectedDeliverySiteId: parseInt(newDelId),
                selectedQuoteId: parseInt(0),
                productList: productsList,
                totalWeight: overallWeight.toFixed(4),
                lorryLoad: truckLoad.toFixed(2)

            };

        case RESET_PRODUCT_BASKET:

            var overallWeight = 0;
            var truckLoad = 0;

            let productList = [...state.productList];
            for (var j in productList) {

                productList[j].packs = parseInt(0);
                productList[j].units = parseInt(0);
                productList[j].totalWeight = parseFloat(0);
                productList[j].quantity = parseInt(0);

            }

            return {
                ...state,
                productList: productList,
                totalWeight: overallWeight.toFixed(4),
                lorryLoad: truckLoad.toFixed(2)

            };

        case SET_ORDER_ERROR:
            return { ...state, errorOccurred: true, errorMessage: action.payload };

        case SET_ORDER_SUMMARY_ERROR:
            return { ...state, errorOccurredSummaryPage: true, errorMessage: action.payload }

        case RETURN_PALLETS:
            return { ...state, palletsRequired: action.payload };

        case TILE_INTEREST:
            return { ...state, tileInterest: action.payload };

        case SET_SEARCH_TEXT:
            return { ...state, searchText: action.payload };
            
        case SET_PRODUCT_LOADING:
            return { ...state, productLoading: action.payload };

        default:
            return state;
    }

}